module.exports = __webpack_public_path__ + "img/card_delay.4bcd525c.png";